<template>
  <custom-dialog :visible="visible" width="1000px" class="replace-parts-dialog" :title="model.title" v-on="$listeners" :appendToBody="true">
    <div class="dialog-body">
      <div class="msg-content">
        <div class="title">{{ $t('asm_replace_parts_dialog.she_bei_xin_xi') }}</div>
        <ul class="msg-list">
          <li v-if="model.data.productBrand">
            <div class="key">{{ $t('asm_replace_parts_dialog.pin_pai') }}</div>
            <div class="val">{{ model.data.productBrand }}</div>
          </li>
          <li>
            <div class="key">{{ $t('asm_replace_parts_dialog.chan_pin_xing_hao') }}</div>
            <div class="val">{{ model.data.productCode }}</div>
          </li>
          <li>
            <div class="key">{{ $t('asm_replace_parts_dialog.ji_shen_hao') }}</div>
            <div class="val">{{ model.data.bodyNum }}</div>
          </li>
        </ul>
      </div>
      <div class="input-container">
        <el-form :model="form" :rules="rules" ref="form">
          <el-row :gutter="8">
            <el-col :span="12">
              <el-form-item :label="$t('asm_replace_parts_dialog.geng_huan_wei_zhi')" prop="componentCode">
                <custom-select
                  url="ComponentReplaceComponentList"
                  type="tree"
                  v-model="form.componentCode"
                  :show-all-levels="false"
                  :params="{ bodyNum: model.data.bodyNum, excludeCodes: model.excludeCodes }"
                  :props="{
                    label: 'componentName',
                    value: 'componentCode',
                    emitPath: false,
                  }"
                  width="100%"
                  ref="component"
                  @treeValChange="componentCodeChange"
                  @getList="onComponentInit"
                  :disabled="isFromReworkItems"
                ></custom-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 内容 -->
          <div class="conten-box">
            <template>
              <el-row :gutter="8">
                <el-col :span="12">
                  <h1 class="item-title">{{ $t('asm_replace_parts_dialog.jljbh') }}</h1>
                  <el-col>
                    <el-form-item :label="$t('asm_replace_parts_dialog.jljbh')" :prop="`partList.oldPartCode`" :rules="rules.oldPartCode">
                      <custom-select
                        url="partList"
                        :filterable="true"
                        :disabled="form.componentCode === 'other' || isFromReworkItems"
                        v-model="form.partList.oldPartCode"
                        :placeholder="$t('Common.com_please_select')"
                        :props="{ label: 'codeName', value: 'partCode' }"
                        remote
                        :listener="form.partList.oldPartCode"
                        :params="{ isLimit: true, keyword: form.partList.oldPartCode }"
                        width="100%"
                        @change="oldPartCodeChange(arguments[0], form.partList)"
                      ></custom-select>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('asm_replace_parts_dialog.jiu_ling_jian_gui_ge')" :prop="`partList.oldPartSpec`">
                      <el-input v-model="form.partList.oldPartSpec" style="100%" :disabled="true"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="`${form.partList.needSn}` !== '0'">
                    <el-row>
                      <el-col :span="19">
                        <el-form-item :label="$t('asm_replace_parts_dialog.jiu_ling_jianSN')" :prop="`partList.oldPartSn`">
                          <el-input v-model="form.partList.oldNewPartSn" style="100%" :disabled="true"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="5">
                        <el-form-item>
                          <label slot="label">&nbsp;</label>
                          <el-button style="width: 100%" type="text" @click="oldPartSnChange(form.partList)">{{ $t('Common.com_modify') }}</el-button>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col v-if="form.partList.partCount > 1">
                    <el-form-item :label="$t('asm_replace_parts_dialog.geng_huan_shu_liang')" :prop="`partList.replaceNum`" :rules="rules.replaceNum">
                      <el-input v-model="form.partList.replaceNum" style="100%"></el-input>
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="12">
                  <h1 class="item-title">{{ $t('asm_replace_parts_dialog.xin_ling_jian_xin_xi') }}</h1>
                  <el-col>
                    <el-form-item :label="$t('asm_replace_parts_dialog.xljbh')" :prop="`partList.partCode`" :rules="rules.partCode">
                      <custom-select
                        url="partList"
                        :filterable="true"
                        v-model="form.partList.partCode"
                        :placeholder="$t('Common.com_please_select')"
                        :props="{ label: 'codeName', value: 'partCode' }"
                        remote
                        :listener="form.partList.partCode"
                        :params="{ isLimit: true, keyword: form.partList.partCode }"
                        width="100%"
                        @change="partCodeChange(arguments[0], form.partList)"
                        :disabled="isFromReworkItems"
                      ></custom-select>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('asm_replace_parts_dialog.xin_ling_jian_gui_ge')" :prop="`partList.partSpec`">
                      <el-input v-model="form.partList.partSpec" style="100%" :disabled="true"></el-input>
                      <!-- {{item.partSpec}} -->
                    </el-form-item>
                  </el-col>
                  <el-col v-if="`${form.partList.needSn}` !== '0'">
                    <el-row>
                      <el-col :span="19">
                        <el-form-item :label="$t('asm_replace_parts_dialog.xin_ling_jianSN')" :prop="`partList.partSn`" :rules="`${form.partList.needSn}` === '1' ? rules.partSn : []">
                          <el-input v-model="form.partList.partSn" style="100%"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="5">
                        <!-- v-if="form.componentCode === 'modem' || form.componentCode === 'btmd'" -->
                        <el-form-item>
                          <label slot="label">&nbsp;</label>
                          <el-button style="width: 100%" type="text" @click="onPartSnSearch(form.partList)">{{ $t('Common.com_query') }}</el-button>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-col>
              </el-row>
              <el-row :gutter="8">
                <el-col>
                  <el-col :span="12">
                    <el-form-item :label="$t('asm_replace_parts_dialog.jljtp')">
                      <div>
                        <t-upload :bizId="bizId" bizType="asm.service.part.old" v-model="oldAttachList" :limit="3" :autoUpload="false" :ref="`asmServicePartOld`"></t-upload>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :label="$t('asm_replace_parts_dialog.xljtp')">
                      <div>
                        <t-upload :bizId="bizId" bizType="asm.service.part.new" v-model="newAttachList" :limit="3" :autoUpload="false" :ref="`asmServicePartNew`"></t-upload>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
            </template>
          </div>
        </el-form>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_close') }}</el-button>
      <el-button type="primary" @click="onSave">{{ $t('Common.com_confirm') }}</el-button>
    </div>
    <!-- 选择设备 -->
    <device-newPartSn-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onOldNewPartSn"></device-newPartSn-dialog>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import tUpload from '@/components/upload.vue';
import deviceNewPartSnDialog from './device_newPartSn_dialog.vue';

export default {
  components: {
    tUpload,
    deviceNewPartSnDialog,
  },
  mixins: [dialogMixins],
  data() {
    return {
      newAttachList: [],
      oldAttachList: [],
      form: {
        // 部件编号
        componentCode: '',
        // 设备Id
        deviceId: '',
        // 是否下发命令 (禁止操作仅查询查看)
        isCommand: '',
        partList: {
          // 部件编号
          componentCode: '',
          // 新零件图片
          newAttachList: [],
          // 旧零件图片
          oldAttachList: [],
          // 旧零件类别，1-普通，2-重大，3-耗材
          oldPartClass: '',
          // 旧零件编号
          oldPartCode: '',
          // 旧零件id
          oldPartId: '',
          // 旧零件名称
          oldPartName: '',
          // 旧零件sn
          oldPartSn: '',
          // 旧零件规格
          oldPartSpec: '',
          // 旧零件类型 asm_part_type
          oldPartType: '',
          // 零件类别，1-普通，2-重大，3-耗材
          partClass: '',
          // 零件编号
          partCode: '',
          // 零件id
          partId: '',
          // 零件名称
          partName: '',
          // 零件sn
          partSn: '',
          // 零件规格
          partSpec: '',
          // 零件类型 asm_part_type
          partType: '',
          // 更换数量
          replaceNum: 1,
        },
      },
      tabActive: 0,

      // 是否是合成部件
      isCombined: '',
      // 合成物的部件编号集合
      combineCodes: '',
      // 是否需要sn  0不要sn 需要显示 partCount 1必须 2选填
      needSn: '',
      // 更换最大值  replaceNum默认是1  needSn才是0显示
      partCount: '',
      //
      partItem: {
        // 部件编号
        componentCode: '',
        // 新零件图片
        newAttachList: [],
        // 旧零件图片
        oldAttachList: [],
        // 旧零件类别，1-普通，2-重大，3-耗材
        oldPartClass: '',
        // 旧零件编号
        oldPartCode: '',
        // 旧零件id
        oldPartId: '',
        // 旧零件名称
        oldPartName: '',
        // 旧零件sn
        oldPartSn: '',
        // 自用 旧零件sn
        oldNewPartSn: '',
        // 旧零件规格
        oldPartSpec: '',
        // 旧零件类型 asm_part_type
        oldPartType: '',
        // 零件类别，1-普通，2-重大，3-耗材
        partClass: '',
        // 零件编号
        partCode: '',
        // 零件id
        partId: '',
        // 零件名称
        partName: '',
        // 零件sn
        partSn: '',
        // 零件规格
        partSpec: '',
        // 零件类型 asm_part_type
        partType: '',
        // 更换数量
        replaceNum: '1',
      },
      dialogVisible: false,
      dialogModel: {},
    };
  },
  computed: {
    rules() {
      return {
        componentCode: [
          {
            required: true,
            message: this.$t('asm_replace_parts_dialog.qxzbjmc'),
          },
        ],
        oldPartCode: [
          {
            required: true,
            message: this.$t('asm_replace_parts_dialog.qxzjljbh'),
          },
        ],
        oldPartSpec: [
          {
            required: true,
            message: this.$t('asm_replace_parts_dialog.qtxjljgg'),
          },
        ],
        oldPartSn: [
          {
            required: true,
            message: this.$t('asm_replace_parts_dialog.qtxjljSN'),
          },
        ],
        replaceNum: [
          { required: true, message: this.$t('asm_replace_parts_dialog.qtxghsl') },
          { min: 1, message: this.$t('asm_replace_parts_dialog.ghslbnxy1') },
          { validator: null, trigger: 'blur', message: this.$t('asm_replace_parts_dialog.ghljslbndyzjbddsl') },
        ],
        partCode: [
          {
            required: true,
            message: this.$t('asm_replace_parts_dialog.qxxljbh'),
          },
        ],
        partSpec: [
          {
            required: true,
            message: this.$t('asm_replace_parts_dialog.qtxljgg'),
          },
        ],
        partSn: [
          {
            required: true,
            message: this.$t('asm_replace_parts_dialog.qtxljSN'),
          },
        ],
      };
    },
    // 是否来自返工项列表
    isFromReworkItems() {
      return this.model.type === 'fromRework';
    },
    bizId() {
      if (this.model.reworkItem) {
        return this.model.reworkItem.orderPartId;
      }
      return '';
    },
  },
  mounted: function () {
    this.form.deviceId = this.model.data.deviceId || '';
    this.form.componentCode = this.model.defaultComponentCode || '';
    const reworkItem = this.model.reworkItem;
    if (reworkItem) {
      this.form.partList.partCount = reworkItem.partCount;
      this.form.partList.replaceNum = reworkItem.newPartCount || 1;
    }
    this.rules.replaceNum[2].validator = (rule, value, callback) => {
      if (value > this.form.partList.partCount) {
        callback(new Error());
      } else {
        callback();
      }
    };
  },
  methods: {
    closeDialog() {
      this.visible = false;
    },
    onComponentInit(list) {
      const allComponent = [];
      list.forEach((item) => {
        allComponent.push(...item.children);
      });
      const defaultComponentCode = this.model.defaultComponentCode;
      if (defaultComponentCode) {
        const selectedItem = allComponent.find((item) => item.componentCode === defaultComponentCode);
        this.componentCodeChange([selectedItem]);
      }
    },
    // 更换位置 部件编号
    componentCodeChange(items) {
      if (items) {
        const currentItem = items.slice(-1)[0];
        this.isCombined = currentItem.isCombined;
        this.combineCodes = currentItem.combineCodes;
        this.needSn = currentItem.needSn;
        this.partCount = currentItem.partCount;
        this.langComponentName = currentItem.langComponentName;
        this.getOldPartInfo();
      }
    },
    // 旧零件
    oldPartCodeChange(info, item) {
      if (info) {
        item.oldPartCode = info.partCode;
        item.oldPartId = info.partId;
        item.oldPartName = info.partName;
        // item.partSn = info.partSn;
        item.oldPartSpec = info.partSpec;
        item.oldPartClass = info.partClass;
        item.oldPartType = info.partType;
        this.clearValidate();
      }
    },
    // 新零件
    partCodeChange(info, item) {
      if (info) {
        item.partCode = info.partCode;
        item.partId = info.partId;
        item.partName = info.partName;
        // item.partSn = info.partSn;
        item.partSpec = info.partSpec;
        item.partClass = info.partClass;
        item.partType = info.partType;
        if (this.form.componentCode === 'other') {
          item.oldPartCode = info.partCode;
          item.oldPartId = info.partId;
          item.oldPartName = info.partName;
          // item.partSn = info.partSn;
          item.oldPartSpec = info.partSpec;
          item.oldPartClass = info.partClass;
          item.oldPartType = info.partType;
        }
        this.clearValidate();
      }
    },
    // 获取旧零件详情
    getOldPartInfo() {
      this.$getJSON(`${apis.stockOldPartInfo}`, {
        bodyNum: this.model.data.bodyNum,
        componentCode: this.form.componentCode,
      }).then((res) => {
        const oldPartInfo = res.data;
        const partCount = this.form.partList.partCount;
        const replaceNum = `${this.form.partList.replaceNum}`; // validator校验的是string
        this.form.partList = { ...this.partItem, partCount, replaceNum };

        if (this.form.componentCode === 'other') {
          // other
          // 位置选其他  旧零件是空的  新零件选了什么 旧零件就是什么
          // 部件编号
          this.form.partList.componentCode = this.form.componentCode;
          // 是否需要sn
          this.form.partList.needSn = this.needSn;
          // 更换最大值
          this.form.partList.partCount = this.form.partList.partCount || this.partCount;
        } else {
          // 部件编号
          this.form.partList.componentCode = this.form.componentCode;
          // 旧零件编号
          this.form.partList.oldPartCode = oldPartInfo.partCode;
          // 旧零件id
          this.form.partList.oldPartId = oldPartInfo.partId;
          // 旧零件名称
          this.form.partList.oldPartName = oldPartInfo.partName;
          // 旧零件sn
          this.form.partList.oldPartSn = oldPartInfo.partSn;
          // 自用旧零件sn
          this.form.partList.oldNewPartSn = oldPartInfo.partSn;
          // 旧零件规格
          this.form.partList.oldPartSpec = oldPartInfo.partSpec;
          // 零件类别
          this.form.partList.oldPartClass = oldPartInfo.partClass;
          // 零件类型
          this.form.partList.oldPartType = oldPartInfo.partType;
          // 是否需要sn
          this.form.partList.needSn = this.needSn;
          // 更换最大值
          this.form.partList.partCount = this.form.partList.partCount || this.partCount;
        }

        // 从返工项中 进入的零件更换 页时, 新零件编号从返工项中获取
        if (this.isFromReworkItems) {
          const partCode = this.model.reworkItem.partCode;
          this.form.partList.partCode = partCode;
          // 如果oldPartCode为空，则取值partCode
          if (!this.form.partList.oldPartCode) {
            this.form.partList.oldPartCode = partCode;
          }
        }

        this.clearValidate();
      });
    },
    async checkSearchSn() {
      const partSn = this.form.partList.partSn;
      const partCode = this.form.partList.partCode;
      if (partSn && this.isFromReworkItems) {
        return this.$getJSON(`${apis.stockNewPartInfo}`, {
          bodyNum: this.model.data.bodyNum,
          componentCode: this.form.componentCode,
          partKey: this.form.partList.partSn,
        }).then((res) => {
          const partInfo = res.data;
          if (partCode !== partInfo.partCode) {
            this.$message({
              message: this.$t('asm_replace_parts_dialog.xljSNybhbpp'),
              type: 'error',
            });
            return Promise.reject();
          }
          return Promise.resolve();
        });
      }
      return Promise.resolve();
    },
    onPartSnSearch() {
      if (this.isFromReworkItems) {
        this.checkSearchSn();
      } else {
        this.$getJSON(`${apis.stockNewPartInfo}`, {
          bodyNum: this.model.data.bodyNum,
          componentCode: this.form.componentCode,
          partKey: this.form.partList.partSn,
        }).then((res) => {
          const partInfo = res.data;
          // 新编号
          this.form.partList.partCode = partInfo.partCode;
          // 新零件id
          this.form.partList.partId = partInfo.partId;
          // 新零件名称
          this.form.partList.partName = partInfo.partName;
          // 新零件sn
          this.form.partList.partSn = partInfo.partSn;
          // 新零件规格
          this.form.partList.partSpec = partInfo.partSpec;
          // 零件类别
          this.form.partList.partClass = partInfo.partClass;
          // 零件类型
          this.form.partList.partType = partInfo.partType;
          // this.form.partList.replaceNum = 1;
          this.clearValidate();
        });
      }
    },
    oldPartSnChange(item) {
      this.dialogModel.title = this.$t('asm_replace_parts_dialog.xgjljSN');
      this.dialogModel.data = item;
      this.dialogVisible = true;
    },
    //
    onOldNewPartSn(form) {
      this.dialogModel.data.oldNewPartSn = form.oldPartSn;
      this.$set(this.dialogModel.data, 'oldNewPartSn', form.oldPartSn);
    },
    clearValidate() {
      if (this.$refs.form) {
        this.$nextTick(() => {
          this.$refs.form.clearValidate();
        });
      }
    },
    getSaveReqData() {
      const obj = this.form.partList;
      const deviceInfo = this.model.data;
      const row = this.model.reworkItem;
      const ret = {
        langComponentName: this.langComponentName,
        oldNewPartSn: obj.oldNewPartSn,
        afterList: this.newAttachList,
        beforeList: this.oldAttachList,
        componentCode: obj.componentCode,
        oldPartCode: obj.oldPartCode,
        oldPartSn: obj.oldPartSn,
        orderDeviceId: deviceInfo.orderDeviceId,
        orderPartId: row ? row.orderPartId || '' : '',
        orderTechnicianId: deviceInfo.orderTechnicianId,
        partCode: obj.partCode,
        partSn: obj.partSn,
        replaceDesc: '',
        replaceNum: obj.replaceNum,
        workOrderId: deviceInfo.workOrderId,
        // 工单服务项ID，返工单时必填
        workOrderItemId: this.isFromReworkItems ? row.workOrderItemId : '',
      };

      return ret;
    },
    async onSave() {
      await this.checkSearchSn();
      this.$refs.form.validate(async (val) => {
        const ret = [];
        ret.push(this.$refs['asmServicePartOld'].submit());
        ret.push(this.$refs['asmServicePartNew'].submit());
        await Promise.all(ret);
        if (val) {
          const reqData = this.getSaveReqData();

          const res = await this.$postJSON(apis.workOrderPartPartReplace, reqData, true);

          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });

          this.$emit('success', res.data);
        }
      });
    },
  },
};
</script>

<style lang="scss">
.replace-parts-dialog {
  .el-form-item__label {
    width: 100%;
    text-align: left;
  }

  .el-select {
    width: 100%;
  }

  .dialog-body {
    width: 100%;
    padding: 0 !important;
    display: flex;
    .msg-content {
      width: 260px;
      padding: 0 24px 40px;
      // height: 100%;
      background: #f8f9fb;
      .title {
        $h: 60px;
        height: $h;
        line-height: $h;
        color: #495057;
        font-weight: bold;
        font-size: 14px;
      }
      .msg-list {
        > li {
          overflow: hidden;
          padding-top: 9px;
          padding-bottom: 10px;
          color: #6c757d;
          font-size: 12px;
          line-height: 17px;
          border-bottom: 1px solid #eef2f7;
          .key {
            float: left;
            width: 50%;
          }
          .val {
            float: left;
            text-align: right;
            width: 50%;
          }
        }
      }
    }
    .input-container {
      flex: 1;
      padding: 24px 24px 0 24px;
      background: #fff;
    }
    .conten-box {
      padding-top: 16px;
    }
  }
}
</style>
